import axios from "@/axios.js";

function getCurrentSession(store) {
  const inMemorySession = store?.state?.session || null;
  let storedSession = null;

  try {
    const raw = localStorage.getItem("enlazado_session");
    if (raw && raw !== "null") {
      storedSession = JSON.parse(raw);
    }
  } catch (error) {
    console.log("Failed to parse persisted session", error);
  }

  const inMemoryTokens = extractSessionTokens(inMemorySession);
  const storedTokens = extractSessionTokens(storedSession);

  if (inMemoryTokens.accessToken && inMemoryTokens.refreshToken) {
    return inMemorySession;
  }

  if (storedTokens.accessToken && storedTokens.refreshToken) {
    return storedSession;
  }

  if (inMemoryTokens.accessToken || inMemoryTokens.refreshToken) {
    return inMemorySession;
  }

  if (storedTokens.accessToken || storedTokens.refreshToken) {
    return storedSession;
  }

  return inMemorySession || storedSession || null;
}

function extractSessionTokens(session) {
  if (!session || typeof session !== "object") {
    return {
      accessToken: null,
      refreshToken: null,
    };
  }

  const nested = session?.user?.session;
  const direct = session?.session;

  return {
    accessToken:
      nested?.access_token || direct?.access_token || session?.access_token || null,
    refreshToken:
      nested?.refresh_token || direct?.refresh_token || session?.refresh_token || null,
  };
}

function hasSessionTokens(session) {
  const { accessToken, refreshToken } = extractSessionTokens(session);
  return Boolean(accessToken && refreshToken);
}

function buildNextSession(currentSession, authContext) {
  const session = currentSession && typeof currentSession === "object"
    ? { ...currentSession }
    : {};

  session.providers = Array.isArray(authContext?.providers)
    ? authContext.providers
    : [];

  if (authContext?.user?.user) {
    const existingUser = session?.user && typeof session.user === "object"
      ? session.user
      : {};
    session.user = {
      ...existingUser,
      user: authContext.user.user,
    };
  }

  return session;
}

async function refreshCurrentUserContext(store) {
  const sessionAtRequestStart = getCurrentSession(store);
  if (!hasSessionTokens(sessionAtRequestStart)) {
    return null;
  }

  const { data } = await axios.get("/api/auth/me");
  const sessionAtCommitTime = getCurrentSession(store);
  if (!hasSessionTokens(sessionAtCommitTime)) {
    return null;
  }

  const nextSession = buildNextSession(sessionAtCommitTime, data);

  store.commit("setSession", nextSession);
  try {
    localStorage.setItem("enlazado_session", JSON.stringify(nextSession));
  } catch (error) {
    console.log("Failed to persist refreshed user context", error);
  }

  return nextSession;
}

export { refreshCurrentUserContext, buildNextSession };
